module.exports = __webpack_public_path__ + "assets/9dd22d9f2edc717ff396ee2b0b92975b.mp3";